const sanitizeNamePart = (value?: string | null): string => {
  if (!value) return 'unknown';
  const cleaned = value.replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  return cleaned === '' ? 'unknown' : cleaned;
};

export const docTypeSlug = (type?: string | null): string => {
  if (!type) return 'other';
  const slug = type
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug === '' ? 'other' : slug;
};

export const buildProofFileName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  type: string | null | undefined,
  shortId: string | null | undefined
): string =>
  `${sanitizeNamePart(firstName)}_${sanitizeNamePart(lastName)}_${docTypeSlug(type)}-${
    shortId || 'unknown'
  }.pdf`;

export const buildBalFileName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => `${sanitizeNamePart(firstName)}_${sanitizeNamePart(lastName)}_bank-linking-report.pdf`;

export const sanitizeSubdir = (value?: string | null): string => sanitizeNamePart(value);
